export interface TarificationApplicationSessionType {
  advanced: boolean;
  baseUrl: string;
  eAttestAvailable: boolean;
  expirationDate?: Date;
  practice: string;
  sessionKey: string;
}

export class TarificationApplicationSession
  implements TarificationApplicationSessionType {
  advanced: boolean;
  baseUrl: string;
  eAttestAvailable: boolean;
  expirationDate?: Date;
  practice: string;
  sessionKey: string;

  constructor(data?: TarificationApplicationSessionType) {
    this.advanced = false;
    this.baseUrl = "";
    this.eAttestAvailable = false;
    this.practice = "";
    this.sessionKey = "";
    data && Object.assign(this, data);
  }
}
